import EventBus from '@/js/util/EventBus'
import player from '@/js/util/props/player'

export default {
  props: {
    tag: {
      type: String,
      default: 'button',
    },

    ...player,
  },
  data() {
    return {
      isLoaded: false,
      isPlaying: false,
      buttonId: undefined,
    }
  },
  created() {
    EventBus.$on('set:loaded', this.setIsLoaded)
    EventBus.$on('set:playing', this.setIsPlaying)
  },
  methods: {
    handleClickEvent() {
      EventBus.$emit('toggle:video', this.playerId)
    },

    setButtonId(buttonId) {
      this.buttonId = buttonId
    },

    setIsPlaying({ playing, id }) {
      if (id !== this.playerId) {
        return
      }
      this.isPlaying = !playing
    },
    setIsLoaded(loaded) {
      this.isLoaded = loaded
    },
  },
  render(createElement) {
    const { isPlaying } = this
    const elementData = {
      // directives: [{
      //   name: 'show',
      //   value: this.isLoaded,
      // }],
      on: { click: this.handleClickEvent },
      class: [
        { 'is-loaded': this.isLoaded },
        { 'is-playing': this.isPlaying },
      ],
    }

    const discernibleContent = createElement('DiscernibleContent', isPlaying ? 'Pause' : 'Play')
    return createElement(this.tag, elementData, [discernibleContent, this.$slots.default])
  },
}



// WEBPACK FOOTER //
// ./src/js/components/player/PlayerButton.js